import settings from '@/settings'

let getCpfDia = (cpf, dia, confirmadas, page, headers) => {
  return fetch(`${settings.apetrusApi}/compras/admin/?cpf=${cpf}&dia=${dia}&confirmadas=${confirmadas}&page=${page}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let getCpfMes = (cpf, mes, confirmadas, page, headers) => {
  return fetch(`${settings.apetrusApi}/compras/admin/?cpf=${cpf}&mes=${mes}&confirmadas=${confirmadas}&page=${page}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let getCpfIntervalo = (cpf, inicio, fim, confirmadas, page, headers) => {
  return fetch(`${settings.apetrusApi}/compras/admin/?cpf=${cpf}&inicio=${inicio}&fim=${fim}&confirmadas=${confirmadas}&page=${page}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let getCnpjDia = (cnpj, dia, confirmadas, page, headers) => {
  return fetch(`${settings.apetrusApi}/compras/admin/?cnpj=${cnpj}&dia=${dia}&confirmadas=${confirmadas}&page=${page}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let getCnpjMes = (cnpj, mes, confirmadas, page, headers) => {
  return fetch(`${settings.apetrusApi}/compras/admin/?cnpj=${cnpj}&mes=${mes}&confirmadas=${confirmadas}&page=${page}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let getCnpjIntervalo = (cnpj, inicio, fim, confirmadas, page, headers) => {
  return fetch(`${settings.apetrusApi}/compras/admin/?cnpj=${cnpj}&inicio=${inicio}&fim=${fim}&confirmadas=${confirmadas}&page=${page}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

// Define ou atualiza o limite da compra
let definirLimite = (data, headers) => {
  return fetch(`${settings.apetrusApi}/compras/limite/`, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(data),
    headers: headers
  })
}

let deletarLimite = (data, headers) => {
  return fetch(`${settings.apetrusApi}/compras/limite/${data.id_limite ? `?id_limite=${data.id_limite}` : `?id_limite_combustivel=${data.id_limite_combustivel}`}`, {
    method: 'DELETE',
    mode: 'cors',
    body: JSON.stringify(data),
    headers: headers
  })
}

let getCompras = (data, headers) => {
  const keys = Object.keys(data)
  let url = `${settings.apetrusApi}/compras/admin/?`
  for (let i = 0; i < keys.length; i++) {
    url = data[keys[i]] !== null && data[keys[i]] !== undefined && data[keys[i]] !== '' ? `${url}${url[url.length - 1] !== '?' ? '&' : ''}${keys[i]}=${data[keys[i]]}` : `${url}`
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let pegarLimite = (headers, isApp) => {
  return fetch(`${settings.apetrusApi}/compras/limite/?isapp=${isApp}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let cancelarCompra = (headers, id) => {
  return fetch(`${settings.apetrusApi}/compras/cancelarcompraadmim/${id}/`, {
    method: 'DELETE',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  getCpfDia,
  getCpfMes,
  getCpfIntervalo,
  getCnpjDia,
  getCnpjMes,
  getCnpjIntervalo,
  definirLimite,
  pegarLimite,
  getCompras,
  cancelarCompra,
  deletarLimite
}
